import DefaultLogo from "./layout/DefaultLogo";

const Policy = () => {
  return (
    <DefaultLogo>
      <div style={{ padding: "10px 4px" }}>
        <h2 className="mb-2" style={{textAlign: "center"}}>Privacy Notice for the VirtuWard Users</h2>
        <div style={{ marginTop: "20px" }}>
          <h6 style={{ marginBottom: "28px" }}>Effective Date: June 2023</h6>
          <p style={{ textAlign: "justify" }}>
            Provide Digital as part of Provide Enterprises Limited{" "}
            <b>(“Provide Enterprises”, “We”,”Us”)</b> as the developer and owner
            of VirtuWard digital platform, including the web portal (the main
            domain of{" "}
            <a href="https://virtuward.com" target="_blank">
              {" "}
              https://virtuward.com
            </a>{" "}
            and its sub-domains) (collectively called{" "}
            <b>“VirtuWard Application”</b>), understands that your privacy is
            important to you and that you care about how your information is
            used and shared. We respect and value the privacy of everyone who
            uses VirtuWard and will only collect and use information in ways
            that are useful to you and in a manner consistent with your rights
            and our obligations under Data Protection law.
          </p>
          <p style={{ textAlign: "justify" }}>
            Provide Enterprises plays a dual role when it comes to processing.
            In some situations, we act as a Controller, in others, we are the
            Processor.
          </p>
          <p style={{ textAlign: "justify" }}>
            When we are a Processor of personal data, we are doing so purely on
            the instruction of another company (the Controller). This will
            usually be the data of healthcare professional or employee of a
            company where VirtuWard Application has been deployed. To find out
            more about how your data is protected by them, you should contact
            them directly.
          </p>
          <p style={{ textAlign: "justify" }}>
            Provide Enterprises, does on occasion, act as a Controller. That
            will usually be the contact data of the company and/or its
            representatives where VirtuWard Application has been deployed and
            then technical data when you use our app.
          </p>
          <p style={{ textAlign: "justify" }}>
            Being a Controller means that we are trusted to look after and deal
            with your personal information in accordance with this notice. We
            determine the ways and means of processing your data and must
            therefore be accountable for it.
          </p>
          <p style={{ textAlign: "justify" }}>
            This Privacy Notice refers to the data we process data as a
            Controller only and describes what <b>personal information</b> we
            collect and hold about you, how we <b>use</b> it, who can{" "}
            <b>access</b> it and <b>your rights </b>
            with regards to how we process your information.
          </p>
          <p style={{ textAlign: "justify" }}>
            The General Data Protection Regulation (GDPR) also gives you the
            right to lodge a complaint with a supervisory authority, in
            particular in a European Economic Area state or in the United
            Kingdom if you work, normally live or if any alleged infringement of
            data protection laws occurred in the relevant state. The supervisory
            authority in the UK is the Information Commissioner who may be
            contacted at{" "}
            <a href="https://ico.org.uk/concerns/" target="_blank">
              https://ico.org.uk/concerns/
            </a>{" "}
            or telephone: 0303 123 1113.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>Who we are</h6>
          <p style={{ textAlign: "justify" }}>
            We are Provide Digital as part of Provide Enterprises Limited, a
            company incorporated in England and Wales with registered number
            12377709 at Companies House and whose registered office is at 900
            The Crescent, Colchester Business Park, Colchester, CO4 9YQ, United
            Kingdom.
          </p>
          <p style={{ textAlign: "justify" }}>
            If you have any questions about this Privacy Notice, please contact
            us by post (Postal Address: 900 The Crescent, Colchester Business
            Park, Colchester, CO4 9YQ, United Kingdom); or email
            <a href="mailto:provide.infogov@nhs.net">
              (provide.infogov@nhs.net)
            </a>
            . Please ensure your query is clear, particularly if it is a request
            for information about the personal data we hold about you. We hope
            that we can resolve any query or concern you raise about our use of
            your information.
          </p>
          <p style={{ textAlign: "justify" }}>
            Provide Enterprises is registered with the Information
            Commissioner’s Office (ICO) to process personal and special
            categories of information (Registration number: ZB407604).
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            Why we keep personal information about you
          </h6>
          <p style={{ textAlign: "justify" }}>
            We may use the personal information we have collected about you for
            the following purpose/s:
          </p>
          <ul>
            <li>
              to understand what you want to build, what features your product
              should have, and what purpose it will serve.
            </li>
            <li>to enter into a contract with us and use the app</li>
            <li>
              to optimise the performance of our app, monitor it for security
              purposes and drive improvements for our users{" "}
            </li>
            <li>
              to provide operation and/or technical support for the tickets
              raised
            </li>
            <li>to send you service updates.</li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            Generally, we do not rely on consent as a legal basis for processing
            your personal data although we will get your consent before sending
            third party direct marketing communications to you via email or text
            message. You have the right to withdraw consent to marketing at any
            time by contacting us.
          </p>
          <p style={{ textAlign: "justify" }}>
            We will only use your personal data for the purposes for which we
            collected it, unless we reasonably consider that we need to use it
            for another reason and that reason is compatible with the original
            purpose. If you wish to get an explanation as to how the processing
            for the new purpose is compatible with the original purpose, please
            contact us. If we need to use your personal data for an unrelated
            purpose, we will notify you and we will explain the legal basis
            which allows us to do so.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            What Information do we keep about you?
          </h6>
          <p style={{ textAlign: "justify" }}>
            We may collect and process the following types of personal
            information:
          </p>
          <ul>
            <li>Name of the company or representative/s</li>
            <li>Email Address of the company or representative/s</li>
            <li>Phone Number of the company or representative/s</li>
            <li>Address of the company</li>
            <li>Logo and other branding material of the company</li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            Apart from the above data, we also process data about the way you
            use our app, including your IP address and browsing time. At Provide
            Enterprises, we believe in being transparent about how we process data
            about you and how we use any third party to process the data.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            How we collect Information about you
          </h6>
          <p style={{ textAlign: "justify" }}>
            We may collect personal information about you in a number of ways:
          </p>
          <ul>
            <li>
              When you make use of our contact form or demo request form to
              request information from us{" "}
            </li>
            <li>When you provide the data to enter into a contract with us</li>
            <li>
              If you sign up on one of our VirtuWard Application that we provide
              and support
            </li>
            <li>When you contact us by phone</li>
            <li>When you use the VirtuWard Application</li>
          </ul>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            Our Lawful basis for processing your data
          </h6>
          <p style={{ textAlign: "justify" }}>
            We may rely on one or more of the following lawful bases for
            processing your personal information:
          </p>
          <ul>
            <li>
              Your consent. You are able to remove your consent at any time. You
              can do this by contacting us through email at{" "}
              <a href="mailto:provide.infogov@nhs.net">
                provide.infogov@nhs.net
              </a>
            </li>
            <li>
              We have a contractual obligation and the processing is necessary
              for the performance of Services we provide pursuant to a contract
              we have entered into with you or your representative.
            </li>
            <li>We have a legal obligation</li>
            <li>We have a legitimate interest assessment</li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            The specific lawful bases will depend on the engagement or services
            you have with us.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            How and where we hold your personal information
          </h6>
          <p style={{ textAlign: "justify" }}>
            We create and hold your records electronically and sometimes in hard
            copy where necessary.
          </p>
          <p style={{ textAlign: "justify" }}>
            Any records we hold about you are held securely and are only
            accessible to those who have a legitimate need to access the
            information.
          </p>
          <p style={{ textAlign: "justify" }}>
            Your information will be kept securely and will remain in the UK. We
            generally store the information provided via VirtuWard Application
            in Amazon Web Services (AWS) Cloud datacentres located in the UK
            where data is encrypted to a high standard (AES256). We also use
            following third party platforms to share and store information (if
            required). Please refer to section –{" "}
            <b>‘Do we share your Information?’</b>
            for further details.
          </p>
          <p style={{ textAlign: "justify" }}>
            We do not typically transfer your personal data outside the European
            Economic Area (EEA). However, should we need to transfer your data
            outside the EEA, we will ensure that the appropriate legal safeguard
            is in place to allow the transfer.
          </p>
          <p style={{ textAlign: "justify" }}>
            All of our staff and contractors receive appropriate and on-going
            training to ensure they are aware of their personal responsibilities
            and have contractual obligations to uphold confidentiality,
            enforceable through disciplinary procedures if necessary. Staff only
            have access to personal information where it is appropriate to their
            role and is strictly on a need-to-know basis.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            How we use your Information
          </h6>
          <p style={{ textAlign: "justify" }}>
            We ensure that we process your data lawfully, fairly and
            transparently in accordance with Data Protection legislation.
          </p>
          <p style={{ textAlign: "justify" }}>
            Personal information collected about you may be used for the
            following purpose/s:
          </p>
          <ul>
            <li>Performance of a contract with you</li>
            <li>Responding to communications from you</li>
            <li>
              Personalising and tailoring your experience on our product/s
            </li>
            <li>
              Supplying you with any information or newsletter you have
              subscribed to
            </li>
            <li>Providing support for our product/s</li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            If we need to use your personal information for any reasons beyond
            those stated above, we will discuss this with you and ask for your
            permission to do so.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            Do we share your Information?
          </h6>
          <p style={{ textAlign: "justify" }}>
            We may share your personal information with other companies within
            our group. This includes our holding company, Provide CIC and its
            subsidiaries.
          </p>
          <p style={{ textAlign: "justify" }}>
            We may sometimes contract with third parties to supply products and
            services to you on our behalf. These may include payment processing,
            delivery of goods, search engine facilities, cloud storage,
            advertising and marketing. In some cases, the third parties may
            require access to some or all of your data. Where any of your data
            is required for such a purpose, we will take all reasonable steps to
            ensure that your data will be handled safely, securely, and in
            accordance with your rights, our obligations, and the obligations of
            the third party under the law.
          </p>
          <p style={{ textAlign: "justify" }}>
            We use third party services for the purposes set out in the table
            below. A list of our external service providers can be found below:
          </p>
          <table
            style={{
              width: "100%",
              border: "1px solid #666",
              marginBottom: "20px",
            }}
          >
            <tr>
              <th style={{ border: "1px solid #666", padding: "6px" }}>
                Service provider
              </th>
              <th style={{ border: "1px solid #666", padding: "6px" }}>
                Service
              </th>
            </tr>
            <tr>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Google Drive
              </td>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Document repository
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Microsoft Email
              </td>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Client email service
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Microsoft OneDrive
              </td>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Document repository
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                SendGrid
              </td>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Email and Customer service
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Codezilla
              </td>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Software development
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Amazon Web Services (AWS)
              </td>
              <td style={{ border: "1px solid #666", padding: "6px" }}>
                Cloud Infrastructure service
              </td>
            </tr>
          </table>
          <p style={{ textAlign: "justify" }}>
            In certain circumstances we may be legally required to share certain
            data held by us, which may include your personal information, for
            example, where we are involved in legal proceedings, where we are
            complying with the requirements of legislation, a court order, or a
            governmental authority. We do not require any further consent from
            you in order to share your data in such circumstances and will
            comply as required with any legally binding request that is made of
            us.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            How long do we keep your Information?
          </h6>
          <p style={{ textAlign: "justify" }}>
            We will only retain your personal data for as long as reasonably
            necessary to fulfil the purposes we collected it for, including for
            the purposes of satisfying any legal, regulatory, tax, accounting or
            reporting requirements. Usually that means we will keep your
            personal data for as long as you have a registered account with
            Provide Enterprises. We may need to retain your personal data for a
            longer period in the event of a complaint, if we reasonably believe
            there is a prospect of litigation in respect to our relationship
            with you or where we have to keep data for regulatory purposes.
          </p>
          <p style={{ textAlign: "justify" }}>
            To determine the appropriate retention period for personal data, we
            consider the amount, nature and sensitivity of the personal data,
            the potential risk of harm from unauthorised use or disclosure of
            your personal data, the purposes for which we process your personal
            data and whether we can achieve those purposes through other means,
            and the applicable legal, regulatory, tax, accounting or other
            requirements.
          </p>
          <p style={{ textAlign: "justify" }}>
            You can unsubscribe from Provide Enterprises emails at any time by
            clicking on the ‘unsubscribe’ button at the bottom of our emails.
          </p>
          <p style={{ textAlign: "justify" }}>
            You can request to delete all your personal data (where applicable)
            by contacting us via email at{" "}
            <a href="mailto:provide.infogov@nhs.net">provide.infogov@nhs.net</a>{" "}
            , and the appropriate personal data will be erased, deleted,
            destroyed, or otherwise disposed of.
          </p>
          <p style={{ textAlign: "justify", fontWeight: "700" }}>Your Rights</p>
          <p style={{ textAlign: "justify" }}>
            You have the following rights, under the Data Protection
            legislation, in respect of your personal information that we hold
            about you:
          </p>
          <ul>
            <li>
              <b>Right of access -</b> To ask for copies of your personal
              information{" "}
            </li>
            <li>
              <b>Right to rectification -</b> To ask for your personal
              information to be corrected if it is inaccurate or incomplete.
            </li>
            <li>
              <b>Right to erasure -</b> To ask for your personal information to
              be deleted or erased, where applicable.
            </li>
            <li>
              <b>Right to restriction of processing - </b>To ask us to restrict
              the use of your personal information in some circumstances.
            </li>
            <li>
              <b>Right to object to processing -</b> To object to the processing
              of your personal information in certain circumstances. We may use
              automated decision making in processing your personal information
              for some services. You may object to your information being
              subjected to automated processing and you can request a manual
              review of the outcome of an automated decision if you are unhappy
              with it.{" "}
            </li>
            <li>
              <b>Right to data portability -</b> To request your personal
              information to be transferred to other providers on certain
              occasions.
            </li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            We do not typically charge a fee for exercising your rights except
            in certain circumstances where permitted by Data Protection law. We
            have one month to respond to your request and may extend by another
            two months in certain circumstances.{" "}
          </p>
          <p style={{ textAlign: "justify" }}>
            If you wish to exercise any of your rights please contact us on{" "}
            <a href="mailto:provide.infogov@nhs.net">provide.infogov@nhs.net</a>{" "}
            or through our data subject request online form/portal by clicking{" "}
            <a href="mailto:provide.infogov@nhs.net">here</a> or by writing to
            our <b>Data Protection Officer</b> at{" "}
            <a href="mailto:provide.infogov@nhs.net">provide.infogov@nhs.net</a>
          </p>
          <p style={{ textAlign: "justify" }}>
            Should you have a query or wish to lodge a complaint about the use
            of your personal information, please contact our Information
            Governance Team in the first instance at{" "}
            <a href="mailto:provide.infogov@nhs.net">provide.infogov@nhs.net</a>{" "}
            or write to:
          </p>
          <p style={{ textAlign: "justify" }}>
            Information Governance, Provide HQ, 900 The Crescent, Colchester
            Business Park, Colchester, Essex, CO4 9YQ
          </p>
          <p style={{ textAlign: "justify" }}>
            If you are still unhappy with the outcome of your enquiry concerning
            how we process your personal information you can write to:{" "}
          </p>
          <p style={{ textAlign: "justify" }}>
            <b>The Information Commissioner,</b> Wycliffe House, Water Lane,
            Wilmslow, Cheshire SK9 5AF.{" "}
          </p>
          <p style={{ textAlign: "justify" }}>
            Telephone: <b>0303 123 1113.</b>
          </p>
          <p style={{ textAlign: "justify" }}>
            ICO Website:{" "}
            <a href="https://www.ico.org.uk" target="_blank">
              https://www.ico.org.uk
            </a>
          </p>
        </div>
      </div>
    </DefaultLogo>
  );
};

export default Policy;
